import { HOMEPAGE_FACILITY_SLOT_COUNT } from './favoriteApi.util';

export const MANAGE_FACILITIES_TITLE = 'Manage Facilities';
export const MANAGE_FACILITIES_HELPER =
  'Choose which 3 facilities appear on your homepage.';
export const MANAGE_FACILITIES_TOOLTIP_HELPER =
  'Choose up to 3 facilities. The order here is the order shown on your homepage.';
export const MANAGE_FACILITIES_ARIA_LABEL = `${MANAGE_FACILITIES_TITLE}. ${MANAGE_FACILITIES_HELPER}`;

export const HOMEPAGE_INSTRUCTION_SELECT =
  'Select up to 3 facilities to show on your homepage.';
export const HOMEPAGE_INSTRUCTION_DRAG =
  'Drag selected facilities to set display order.';
export const HOMEPAGE_INSTRUCTION_APPEAR =
  'Only the first 3 selected facilities will appear here.';

export const HOMEPAGE_INSTRUCTIONS = [
  HOMEPAGE_INSTRUCTION_SELECT,
  HOMEPAGE_INSTRUCTION_DRAG,
  HOMEPAGE_INSTRUCTION_APPEAR,
] as const;

export const MY_FACILITIES_INSTRUCTION =
  'Select up to 3 facilities to display on your homepage. Drag the selected facilities to set the order they appear.';

export const homepageSectionTitle = (max = HOMEPAGE_FACILITY_SLOT_COUNT) =>
  `Homepage Facilities (${max} max)`;

export const HOMEPAGE_DRAG_REORDER_HINT = 'Drag to reorder display priority';
export const HOMEPAGE_PANEL_HINT =
  'Use ↑ to add a facility to your homepage, or ↓ on a slot to remove it.';
export const HOMEPAGE_EMPTY_SLOT_HINT = 'Empty — add from All Facilities below';
export const HOMEPAGE_SLOT_EMPTY = 'Empty slot';

export const SHOWN_ON_HOMEPAGE_BADGE = 'Shown on homepage';
export const ADD_TO_HOMEPAGE_TOOLTIP = 'Add to homepage';
export const REMOVE_FROM_HOMEPAGE_TOOLTIP = 'Remove from homepage';
export const DELETE_FACILITY_TOOLTIP = 'Remove saved facilities';
export const DELETE_FACILITY_TOOLTIP_HELPER =
  'Open saved facilities and tap the star to remove a site.';
export const REMOVE_SAVED_FACILITY_TOOLTIP = 'Remove from saved facilities';
export const DELETE_FACILITY_CONFIRM_TITLE = 'Remove facility?';
export const DELETE_FACILITY_CONFIRM_CANCEL = 'Cancel';
export const DELETE_FACILITY_CONFIRM_ACTION = 'Remove';
export const formatDeleteFacilityConfirmBody = (facilityName: string) =>
  `Are you sure you want to remove "${facilityName}" from My Facilities?`;
export const REMOVE_FACILITIES_TITLE = 'Remove Facilities';
export const REMOVE_FACILITIES_HELPER =
  'Tap the filled star to remove a facility from My Facilities.';
export const REMOVE_FACILITIES_LIST_HINT =
  'Facilities stay in alphabetical order. Tap the filled star to remove a site.';

export const HOMEPAGE_SLOT_LABELS = [
  { slot: 'Slot 1', role: 'Primary facility' },
  { slot: 'Slot 2', role: 'Secondary facility' },
  { slot: 'Slot 3', role: 'Third facility' },
] as const;

export const ALL_FACILITIES_SECTION = 'All Facilities';
export const ALL_FACILITIES_LIST_HINT =
  'Facilities stay in alphabetical order. Use ↑ to add to homepage.';

export const MANAGE_CARD_TITLE = 'Manage Facilities';
export const MANAGE_CARD_SUBTEXT = 'Add or change facilities';
export const MANAGE_CARD_ARIA_LABEL = `${MANAGE_CARD_TITLE}. ${MANAGE_CARD_SUBTEXT}`;

export const formatHomepageSelectedCount = (
  count: number,
  max = HOMEPAGE_FACILITY_SLOT_COUNT
) => `${count} of ${max} selected`;
